import { useEffect, useMemo, useState } from "react";
import { useAppSelector } from "@/v2/hooks/useTypedRedux";

interface FilterItem {
  filterBy: string;
  filter: unknown;
}

interface FiltersMerged {
  [key: string]: unknown;
}

/**
 * @deprecated Use `useFilterState` from '@/v2/hooks' instead.
 * This hook reads from Redux and will be removed in a future version.
 */
export const useFilters = () => {
  const [filters, setFilters] = useState<FilterItem[] | null>(null);
  const savedFilters = useAppSelector((state) => state.screen.filterValue);

  useEffect(() => setFilters(savedFilters || null), [savedFilters]);

  const filtersMerged = useMemo((): FiltersMerged | null => {
    if (filters) {
      return filters.reduce<FiltersMerged>((result, filter) => {
        result[filter.filterBy] = filter.filter;
        return result;
      }, {});
    }

    return null;
  }, [filters]);

  return { filters, filtersMerged };
};
